<template>
  <div id="app-main">
    <router-view ></router-view>

  </div>
</template>

<script>

// document.documentElement.style.fontSize = (document.documentElement.clientHeight / 1280) * 10 + 'px'

import { mapActions } from 'vuex'

export default {
  data () {
    return {
      showShareUpgradeRewards: false,
      earnMoneyTips: false,
      taskDialog: false,
    }
  },
  methods: {
    ...mapActions(['appConfig']),
    handleResize () {
      if (window.matchMedia('(orientation: portrait)').matches) {
        // 设备处于竖屏状态
        document.documentElement.style.fontSize = (document.documentElement.clientWidth / 720) * 10 + 'px'
      } else if (window.matchMedia('(orientation: landscape)').matches) {
        // 设备处于横屏状态
        document.documentElement.style.fontSize = (document.documentElement.clientHeight / 720) * 10 + 'px'
      }
    },
    fullScreen () {
      try {
        if (document.fullscreenElement) {
          return
        }
        const element = document.documentElement
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    // 首个页面挂载前把登录态和身份参数恢复进 store：提现页是整页重新加载进来的，挂载时就要用 token
    try {
      this.appConfig()
    } catch (e) {
      console.log(e)
    }

    window.addEventListener('message', (event) => {
      try {
        console.log('sdk received:' + event.data)
        if (event.data === 'closePage') {
          if (window.webkit && window.webkit.messageHandlers) {
            this.$router.push('/main/earn_cash/0')
          } else {
            this.$router.go(-1)
          }
        } else {
          const data = JSON.parse(event.data)
          if (data.closeIframeId === 'customer-iframe') {
            this.$router.go(-1)
          } else if (data.action === 'share_tip') {
            this.$router.push('/main/earn_cash/1')
          }
        }
      } catch (e) {
        console.log(e)
      }
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
}

</script>
<style>
.dialog_contain {
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  z-index: 50;
  top: 0;
  justify-content: center;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  width: 100%;
  height: 100%;
  font-family: Arial, serif;
}

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  background-image: url("@/assets/app_bg.png");
  background-size: cover;
  align-content: center;
}

@media screen and (orientation: portrait) {
  app-main {
    height: 100vw;
    width: 169vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    overflow: hidden;
  }
}

@media screen and (orientation: landscape) {
  app-main {
    width: 169vh;
    height: 95vh;
    display: flex;
    position: relative;
    align-self: center;
    justify-content: center;
    overflow: hidden;
  }
}
</style>
